/**
 * @generated SignedSource<<4b3b39a6356018f3244c69cfa1c938fa>>
 * @relayHash ec3093320eb13b2bee6ee88cd50f85ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0fa7d224fcd039cc5a6a3a5a0f2cddce895391f48b692cf3e7a84d1e25e4b12c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlanListRefactoredQuery$variables = {
  cloudId: string;
  currentURLPath?: AGG$URL | null | undefined;
  entityAriPlans?: string | null | undefined;
  ownerAri?: string | null | undefined;
};
export type PlanListRefactoredQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PlansListRefactored">;
};
export type PlanListRefactoredQuery = {
  response: PlanListRefactoredQuery$data;
  variables: PlanListRefactoredQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentURLPath"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAriPlans"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  }
],
v1 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v6 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              (v4/*: any*/)
            ]
          },
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v4/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "url"
                  }
                ],
                "type": "JiraSoftwareBuiltInNavigationItem"
              },
              (v5/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v5/*: any*/)
    ]
  }
],
v7 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PlanListRefactoredQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "currentURLPath",
            "variableName": "currentURLPath"
          },
          {
            "kind": "Variable",
            "name": "entityAriPlans",
            "variableName": "entityAriPlans"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PlansListRefactored"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlanListRefactoredQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "favouritePlans",
            "args": [
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "sort": {
                    "order": "DESC"
                  },
                  "type": "PLAN"
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 15
              }
            ],
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v6/*: any*/)
              },
              (v7/*: any*/)
            ]
          },
          {
            "alias": "recentPlans",
            "args": [
              (v2/*: any*/),
              {
                "kind": "Variable",
                "name": "currentURL",
                "variableName": "currentURLPath"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "PLAN"
                ]
              }
            ],
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v6/*: any*/)
              },
              (v7/*: any*/)
            ]
          }
        ]
      },
      {
        "alias": "plansOrder",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAriPlans"
          },
          (v1/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": [
          {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visible"
                  }
                ]
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "0fa7d224fcd039cc5a6a3a5a0f2cddce895391f48b692cf3e7a84d1e25e4b12c",
    "metadata": {},
    "name": "PlanListRefactoredQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c45b7037a44c0c7e46e793f645555d0a";

export default node;
